(function ($) {
    $(() => {

       if($('.newsletter-websolution').length > 0) {
            var hash = window.location.hash;

            if(hash == '#success') {
                swal({
                    title: 'Successfully subscribed',
                    icon: 'success',
                    button: 'ok'
                });

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".newsletter-websolution").offset().top
                }, 500);
            }

            if(hash.indexOf("RECAPTCHA_INVALID") >= 0) {
                swal({
                    title: 'Invalid recaptcha, please ty again!',
                    icon: 'error',
                    button: 'ok'
                });

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".newsletter-websolution").offset().top
                }, 500);
            }

            if(hash == '#error') {
                swal({
                    title: 'An error has occurred, please ty again!',
                    icon: 'error',
                    button: 'ok'
                });

                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".newsletter-websolution").offset().top
                }, 500);
            }

            window.location.hash = ''
       }

        // front-form
       /*  $('.js-web-newsletter').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            const formdata = $this.serializeArray();

            let array = [];
            formdata.map(function (item) {
                array[item.name] = item.value;
            });

            let info = $('#press').is(':checked') ? $('#press').val() + $('#stock').is(':checked') ? ', ' + $('#stock').val() : null : $('#stock').is(':checked') ? $('#stock').val() : null

            $.ajax({
                url: '//publish.ne.cision.com/Subscription/SubscribeWithCaptcha',
                type: 'POST',
                data: {
                    subscriptionUniqueIdentifier: '95edfa4e39',
                    Replylanguage: 'en',
                    Name: $('#name').val(),
                    Email: $('#email').val(),
                    companyname: $('#companyname').val(),
                    informationtype: info,
                    'g-recaptcha-response': array['g-recaptcha-response']
                },
                success(data) {
                    
                   
                }
            }).done(response => {
                $this.find('.contact-btn').prop('disabled', false);
            });
        });
 */

    });
})(jQuery);